import React from "react";
import "./CategoryCard.scss";
import fallbackImg from "../../Assets/icons/cardFallback.svg";
import { ImageLink } from "../../constants";
import { useNavigate } from "react-router-dom";

const CategoryCard = ({ details, className = "", description = false }) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    navigate(details.path);
  };
  const handleButtonClick = (e) => {
    e.stopPropagation(); 
    navigate(details.path);
  };

  return (
    <div
      className={`helpCard ${className}`}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
    >
      <div className="card-content">
        <img
          className="card-image"
          src={details.image?.length ? ImageLink(details.image) : fallbackImg}
          alt={details.name}
        />

        <div className="card-text">
          <p className="titles">{details.name}</p>
          {description && (
            <div className="message">{details.description}</div>
          )}
        </div>

        {/* Desktop button */}
        <button
          className="explore-btn"
          onClick={handleButtonClick}
        >
          Explore
        </button>
      </div>
    </div>
  );
};

export default CategoryCard;
